<ngb-datepicker
  #datePicker
  class="date-picker"
  [minDate]="minimumAllowedDate()"
  [maxDate]="maximumAllowedDate()"
  (dateSelect)="dateSelected($event)"
  [dayTemplate]="customDayTemplate"
  [contentTemplate]="c"
  [weekdays]="false"
  [firstDayOfWeek]="7"
  tabindex="-1"
  navigation="none">
</ngb-datepicker>

<ng-template #customDayTemplate let-date>
  <span
    class="date-picker-day"
    [class.selected]="date.equals(selectedEndRangeDate) || date.equals(selectedDate)"
    [class.inside-range]="isInsideSelectedRange(date)"
    [class.outside-day]="isInsideMinMaxLimits(date)">
    {{ date.day }}
  </span>
</ng-template>

<ng-template #c let-dp>
  <div class="px-3 py-4">
    <div class="d-flex mb-4">
      <lib-button
        class="d-flex me-4"
        [type]="ButtonType.tertiary"
        [trailingIconName]="'chevron-down'"
        [floatUi]="monthPicker"
        [showTrigger]="NgxFloatUiTriggers.click"
        [placement]="NgxFloatUiPlacements.BOTTOMSTART"
        [hideOnScroll]="true">
        {{ dp.i18n.getMonthShortName(dp.state.firstDate.month) }}
      </lib-button>
      <lib-button
        class="d-flex me-auto"
        [type]="ButtonType.tertiary"
        [trailingIconName]="'chevron-down'"
        [floatUi]="yearPicker"
        [showTrigger]="NgxFloatUiTriggers.click"
        [placement]="NgxFloatUiPlacements.BOTTOMSTART"
        [hideOnScroll]="true">
        {{ dp.state.firstDate.year }}
      </lib-button>
    </div>
    <div class="">
      @for (month of dp.state.months; track $index) {
        <div>
          <div class="d-flex justify-content-between align-items-center mb-2">
            <mat-icon class="date-picker-month-icon" [svgIcon]="'chevron-left'" (click)="navigateMonth(-1)"></mat-icon>
            <div class="date-picker-month-title">
              {{ dp.i18n.getMonthFullName(month.month) }}
            </div>
            <mat-icon class="date-picker-month-icon" [svgIcon]="'chevron-right'" (click)="navigateMonth(1)"></mat-icon>
          </div>
          <div class="date-picker-days-of-week">
            <div i18n>Su</div>
            <div i18n>Mo</div>
            <div i18n>Tu</div>
            <div i18n>We</div>
            <div i18n>Th</div>
            <div i18n>Fr</div>
            <div i18n>Sa</div>
          </div>
          <ngb-datepicker-month class="date-picker-month" [month]="month"></ngb-datepicker-month>
        </div>
      }
    </div>
    <div class="d-flex mt-4">
      <lib-button (buttonClick)="resetClicked()" [type]="ButtonType.tertiary" class="ms-auto me-4" i18n>
        Reset
      </lib-button>
    </div>
  </div>

  <float-ui-content #monthPicker>
    <div class="month-year-picker">
      @for (monthOption of monthOptions; track $index) {
        <span class="month-year-picker-item" (click)="monthSelected(monthOption.value); monthPicker.hide()">
          {{ monthOption.label }}
        </span>
      }
    </div>
  </float-ui-content>

  <float-ui-content #yearPicker>
    <div class="month-year-picker">
      @for (yearOption of yearOptions(); track $index) {
        <span class="month-year-picker-item" (click)="yearSelected(yearOption.value); yearPicker.hide()">
          {{ yearOption.label }}
        </span>
      }
    </div>
  </float-ui-content>
</ng-template>
